import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { homePurchaseGoalsSelector } from '../../../GoalsCRUDSelector';
import AdvWorkflowStep from '../../../AdvWorkflowStep/AdvWorkflowStepContainer';
import Back from '../../../Navigation/Back/BackContainer';
import { iterator as selectIterator } from '../../../AdvWorkflow/AdvWorkflowSelector';
import { onAddGoal, onDeleteGoal, onEditGoal } from './HomePurchaseCRUD.actions';
import { useClientId } from '../../../../_hooks/useClientId';
import { isVisible as getIsVisible } from '../../../AdvWorkflow/AdvWorkflowHelpers';
import { fetchData } from '../../../AdvWorkflow/AdvWorkflowActions';
import { DeleteGoalModal } from '../../../../ProfileOPL/Goals/components/DeleteGoalModal/DeleteGoalModal';

interface Props {
  branch: (number | string)[];
  workflowId: string;
}

export const HomePurchaseCRUD = (props: Props) => {
  const [goalIdToDelete, setGoalIdToDelete] = useState<string | null>(null);

  const clientId = useClientId();

  // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
  // @ts-ignore
  const homePurchaseGoals = useSelector(state => homePurchaseGoalsSelector(state, props));
  // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
  // @ts-ignore
  const iterator = useSelector(state => selectIterator(state, props));

  const dispatch = useDispatch();

  const { branch, workflowId } = props;

  const isVisible = getIsVisible(branch, iterator);

  useEffect(() => {
    if (isVisible) {
      dispatch(fetchData(workflowId, clientId, [], true));
    }
  }, [clientId, dispatch, isVisible, workflowId]);

  return (
    <>
      <AdvWorkflowStep branch={branch} workflowId={workflowId} canSkip={false}>
        <Back workflowId={workflowId} validationId="" />

        <div className="AccountsOverviewView">
          <h2 className="h2">Manage your home purchase goals</h2>
          <h3 className="h4">Add a new goal or edit an existing one</h3>
          <div className="adv-workflow-crud-widget">
            {homePurchaseGoals.length === 0 ? (
              <div className="adv-workflow-crud-empty">
                <div className="adv-workflow-crud-empty-add">
                  <button
                    className="adv-workflow-crud-empty-add-button"
                    type="button"
                    onClick={() => {
                      dispatch(onAddGoal(workflowId, clientId));
                    }}
                  >
                    <i className="adv-workflow-crud-empty-add-button-i">+</i>
                    <br />
                    Add a new home purchase goal
                  </button>
                </div>
              </div>
            ) : (
              <div className="adv-workflow-crud-populated">
                <ul className="adv-workflow-crud-populated-ul">
                  {homePurchaseGoals.map(goal => {
                    return (
                      <li className="adv-workflow-crud-populated-li" key={goal.Id}>
                        <div className="adv-workflow-crud-populated-name-2">{goal.Name}</div>
                        <div className="adv-workflow-crud-populated-value-2">
                          {goal.DesiredPurchaseYear}
                        </div>
                        <div className="adv-workflow-crud-populated-actions">
                          <button
                            type="button"
                            className="adv-workflow-crud-populated-action"
                            aria-label="edit home purchase"
                            onClick={() => {
                              dispatch(onEditGoal(goal, workflowId, clientId));
                            }}
                          >
                            <i className="adv-workflow-crud-populated-action-i far fa-edit" />
                          </button>
                          <button
                            type="button"
                            className="adv-workflow-crud-populated-action"
                            aria-label="remove home purchase"
                            onClick={() => {
                              setGoalIdToDelete(goal.Id);
                            }}
                          >
                            <i className="adv-workflow-crud-populated-action-i far fa-trash-alt" />
                          </button>
                        </div>
                      </li>
                    );
                  })}
                </ul>
                <div className="adv-workflow-crud-populated-add">
                  <button
                    className="adv-workflow-crud-populated-add-button"
                    onClick={() => {
                      dispatch(onAddGoal(workflowId, clientId));
                    }}
                    type="button"
                  >
                    <i className="adv-workflow-crud-populated-add-button-i">+</i>
                    Add a new home purchase goal
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </AdvWorkflowStep>

      {goalIdToDelete && (
        <DeleteGoalModal
          clientId={clientId.toString()}
          goalId={goalIdToDelete}
          onClose={() => setGoalIdToDelete(null)}
          onSuccess={() => {
            dispatch(onDeleteGoal(goalIdToDelete, workflowId, clientId, homePurchaseGoals));
            setGoalIdToDelete(null);
          }}
        />
      )}
    </>
  );
};
